/**
 * @generated SignedSource<<e1df2857121021c08d4a9ba27738a24d>>
 * @relayHash d77704449727a4fba85ef3393fa73580
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5bd0701ceaa0fe9c8c090a00b4ac1dd90cf504110fc3b0e5741c489a8400b2d2

import type { ConcreteRequest } from 'relay-runtime';
export type WatchSettingsCheckboxItemsWatchDialogUnwatchSpaceMutation$variables = {
  spaceId: string;
};
export type WatchSettingsCheckboxItemsWatchDialogUnwatchSpaceMutation$data = {
  readonly unwatchSpace: {
    readonly space: {
      readonly currentUser: {
        readonly isWatched: boolean;
      };
      readonly id: string | null | undefined;
    };
  } | null | undefined;
};
export type WatchSettingsCheckboxItemsWatchDialogUnwatchSpaceMutation = {
  response: WatchSettingsCheckboxItemsWatchDialogUnwatchSpaceMutation$data;
  variables: WatchSettingsCheckboxItemsWatchDialogUnwatchSpaceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceId"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Literal",
            "name": "currentUser",
            "value": true
          },
          {
            "kind": "Variable",
            "name": "spaceId",
            "variableName": "spaceId"
          }
        ],
        "kind": "ObjectValue",
        "name": "watchSpaceInput"
      }
    ],
    "concreteType": "WatchSpacePayload",
    "kind": "LinkedField",
    "name": "unwatchSpace",
    "plural": false,
    "selections": [
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isWatched"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchSpaceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchSpaceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d77704449727a4fba85ef3393fa73580",
    "id": "5bd0701ceaa0fe9c8c090a00b4ac1dd90cf504110fc3b0e5741c489a8400b2d2",
    "metadata": {},
    "name": "WatchSettingsCheckboxItemsWatchDialogUnwatchSpaceMutation",
    "operationKind": "mutation",
    "text": "mutation WatchSettingsCheckboxItemsWatchDialogUnwatchSpaceMutation($spaceId:ID!){unwatchSpace(watchSpaceInput:{spaceId:$spaceId,currentUser:true}){space{id,currentUser{isWatched}}}}"
  }
};
})();

(node as any).hash = "8c5e29a2e28ada8e000ea45eac9b0b5d";

export default node;
